console.log('js/recommended-listing.js -> v0.1.0');
(() => {

    if(document.querySelector('.recommended-listing')){

        let isInViewport = function (elem) {
            let bounding = elem.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };

        var isCalledBefore = 0

        let listing = document.querySelector('.recommended-listing');
        window.addEventListener('scroll', function (event) {
            if (isInViewport(listing) && isCalledBefore == 0) {
                fetchRecommendations();
                isCalledBefore = 1;
            }
        }, false);

        function fetchRecommendations() {

			const desiredAmountOfRecommendations = 5;
            const queryParams = new URLSearchParams(window.location.search);
            const arrivalDate = queryParams.get("arrival_date");
			const flexible = queryParams.get("flexible");
            var recommendations = [];
            var recommendationsHtml = '';
            const listingId = document.querySelector('.recommended-listing-id').getAttribute('data-id');
			let recommendationsUrl = `/recommendations/listing_page/available/${listingId}?amount=${desiredAmountOfRecommendations}`;
            if(arrivalDate || flexible){
                recommendationsUrl = `/recommendations/listing_page/available/${listingId}?arrival_date=${arrivalDate}&flexible=${flexible}&amount=${desiredAmountOfRecommendations}`;
			}

			let headers = new Headers();
			headers.set('X-Requested-With', 'XMLHttpRequest');
			headers.set('Content-Type', 'application/json');

			const params = {
				method: 'GET',
				headers: headers
			}

            fetch(recommendationsUrl, params)
                .then(response => response.json())
                .then(body => {
                    recommendations = body;
                    if(recommendations.length > 0){
                        recommendations.forEach( recommendation => {
                            let priceContent = '';
                            if(recommendation.discountPriceNoDecimalWithSymbol != '') {
                                priceContent = `<div>${discountStartsFromLabel}</div><div><span class="recommended-listing__overlay__price__discount">${recommendation.priceNoDecimalWithSymbol}</span><strong> ${recommendation.discountPriceNoDecimalWithSymbol}</strong></div>`
                            }
                            else {
                                priceContent = `${fromLabel} <span>${recommendation.priceNoDecimalWithSymbol}</span>`
                            }
                            avgReviewScore = recommendation.reviewScore * 10;
                            recommendationsHtml += ` <div class="recommended-listing__card">
                                                        <a href="${recommendation.listingUrl}" target="_blank" class="recommended-listing__left">
                                                            <div class="recommended-listing__image">
                                                                <img src="${recommendation.nonMobilePhotoUrl}" alt="" loading="lazy" style="width: 100%;">
                                                            </div>
                                                            <div class="recommended-listing__overlay">
                                                                <div class="recommended-listing__overlay__price">${priceContent}</div>
                                                            </div>
                                                        </a>
                                                        <div class="recommended-listing__right">
                                                            <a href="${recommendation.listingUrl}" target="_blank" class="recommended-listing__text">
                                                                <div class="recommended-listing__title">${recommendation.listingTitle}</div>
                                                            </a>
                                                            <a href="${recommendation.listingUrl}" target="_blank" class="recommended-listing__score ${avgReviewScore <=0 ? 'recommended-listing__score__hide' : ''} ">
                                                                <div class="star-visuals">
                                                                    <i class="ebs-icon ${avgReviewScore < 10 ? 'ebs-icon-t-star-empty' : ''} ${avgReviewScore >= 10 && avgReviewScore < 20 ? 'ebs-icon-t-star-half' : ''} ${avgReviewScore >= 20 ? 'ebs-icon-t-star-full' : ''} "></i>
                                                                    <i class="ebs-icon ${avgReviewScore < 30 ? 'ebs-icon-t-star-empty' : ''} ${avgReviewScore >= 30 && avgReviewScore < 40 ? 'ebs-icon-t-star-half' : ''} ${avgReviewScore >= 40 ? 'ebs-icon-t-star-full' : ''} "></i>
                                                                    <i class="ebs-icon ${avgReviewScore < 50 ? 'ebs-icon-t-star-empty' : ''} ${avgReviewScore >= 50 && avgReviewScore < 60 ? 'ebs-icon-t-star-half' : ''} ${avgReviewScore >= 60 ? 'ebs-icon-t-star-full' : ''} "></i>
                                                                    <i class="ebs-icon ${avgReviewScore < 70 ? 'ebs-icon-t-star-empty' : ''} ${avgReviewScore >= 70 && avgReviewScore < 80 ? 'ebs-icon-t-star-half' : ''} ${avgReviewScore >= 80 ? 'ebs-icon-t-star-full' : ''} "></i>
                                                                    <i class="ebs-icon ${avgReviewScore < 90 ? 'ebs-icon-t-star-empty' : ''} ${avgReviewScore >= 90 && avgReviewScore < 100? 'ebs-icon-t-star-half' : ''} ${avgReviewScore >= 100? 'ebs-icon-t-star-full' : ''} "></i>
                                                                </div>
                                                                <a href="${recommendation.listingUrl}#reviews" class="js-showcard-link ${avgReviewScore <=0 ? 'recommended-listing__score__hide' : ''} ">
                                                                    &middot; <span>${recommendation.reviewsCount}</span>
                                                                </a>
                                                            </a>
                                                        </div>
                                                    </div>`
                        })
                        const listingContainer = document.querySelector('.recommended-listing .listing');
                        listingContainer.innerHTML = recommendationsHtml;
                    }
                    else {
                        const listingSection = document.querySelector('.recommended-listing.right-column');
                        listingSection.remove();
                    }
                })
                .catch(error => {
                    const listingSection = document.querySelector('.recommended-listing.right-column');
                    listingSection.remove();
                });
        }
    }
})();
